import React, { ReactNode } from 'react';
import Link from 'next/link';

import IconArrowRight from 'components/IconArrowRight';

type CardProps = {
  as?: string;
  children?: ReactNode;
  className?: string;
  ctaTitle?: string;
  href: string;
  image: ReactNode;
  title: string;
  trackerClass: string;
};

const Card = ({ as, children, className, ctaTitle, href, image, title, trackerClass }: CardProps) => (
  <Link
    href={href}
    as={as}
    className={`group flex w-full cursor-pointer flex-col justify-between bg-white transition-all  duration-200 ease-in-out hover:shadow-3 ${
      className ? className : ''
    } ${trackerClass}`}
  >
    {image}
    <div className="flex flex-grow flex-col items-start space-y-8 p-16 md:p-32">
      <div className="flex-grow space-y-8">
        <h3 className="group-hover:text-gold-darker text-h4 transition-all duration-200 ease-in-out" style={{ willChange: 'color' }}>
          {title}
        </h3>

        {children && <div>{children}</div>}
      </div>

      {ctaTitle && (
        <div
          className="text-gold-darker hover:border-gold-darker text-h5 flex items-center space-x-4 border-b-1 border-transparent transition-all duration-200 ease-in-out"
          style={{ willChange: 'color' }}
        >
          <div>{ctaTitle}</div>
          <IconArrowRight className="!text-gold-darker" />
        </div>
      )}
    </div>
  </Link>
);

export default Card;
